export function getJobStatusURL(jobId: string): string | undefined {
	if (!jobId) {
		return undefined;
	}

	return `/authenticated/data/jobs/${jobId}`;
}
